<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="(campanha ? campanha.nome : 'NENHUMA CAMPANHA') | uppercase" disabled="disabled" readonly="readonly">
</ng-template>

<ng-template [ngIf]="!disabled">
    <select 
        #select
        class="form-control" 
        [name]="name"
        [id]="id"
        [required]="required"
        [autofocus]="autofocus"
        [ngModel]="ngModel || ''" 
        (ngModelChange)="onChange($event ? $event : null)">
        <option value="">NENHUMA CAMPANHA</option>
        <optgroup *ngFor="let area of areasCampanhas" [label]="area.nome">
            <option *ngFor="let campanha of area.campanhas" [ngValue]="campanha.id" [disabled]="!isEmAndamento(campanha.status)">{{campanha.nome | uppercase}}</option>
        </optgroup>        
    </select>  
</ng-template>